import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalSpinnerService } from '../services/global-spinner.service';
import { SnackBarService } from '../services/snackbar.service';
import { LoginService } from '../login/login.service';
import { finalize, switchMap } from 'rxjs/operators';
import { ServerErrorUtils } from 'src/app/shared/utils/server-error-utils';
import { Observable, of } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { MyErrorStateMatcher } from 'src/app/shared/domain/shared.model';

@Component({
  selector: 'ctv-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss']
})
export class NewPasswordComponent {
  private recoveryId: string;
  public tokenExpired: boolean;
  public readonly errorStateMatcher = new MyErrorStateMatcher();

  public form = new FormGroup({
    newPassword: new FormControl<string>('', [Validators.required, RxwebValidators.password({validation:{minLength: 8, digit: true,specialCharacter: true, upperCase: true}})]),
    confirmPassword: new FormControl<string>('', [Validators.required, RxwebValidators.password({validation:{minLength: 8, digit: true,specialCharacter: true, upperCase: true}}), RxwebValidators.compare({fieldName: 'newPassword'})])
  });

  constructor(
    private readonly loginService: LoginService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly snackBarService: SnackBarService,
    private readonly globalSpinnerService: GlobalSpinnerService
  ){
    this.globalSpinnerService.showLoader();
    this.recoveryId = this.activatedRoute.snapshot.paramMap.get('recoveryId');
    this.checkIfTokenActive();
  }

  private checkIfTokenActive() {
    this.loginService.isRecoveryTokenActive(this.recoveryId)
    .pipe(
      finalize(() => this.globalSpinnerService.hideLoader())
    )
    .subscribe(
      () => {},
      (error) => {
        // this.tokenExpired = true;
      }
    );
  }

  public submit() {
    this.globalSpinnerService.showLoader();
    this.loginService.isRecoveryTokenActive(this.recoveryId)
    .pipe(
      switchMap((response) => response ? this.setNewPassword() : of({})),
      finalize(() => this.globalSpinnerService.hideLoader())
    )
    .subscribe(
        (data) => {
          this.snackBarService.success('Password successfully set');
        },
        (error) => {
          const messages = ServerErrorUtils.getValidationMessages(error);
          if (messages) {
            messages.forEach(m => this.snackBarService.error(m));
          } else {
            this.snackBarService.error('Error while trying to set new password.');
        }}
      );
  }

  public setNewPassword(): Observable<any> {
    return this.loginService.resetPassword(this.recoveryId, this.form.get('newPassword').value, this.form.get('confirmPassword').value);
  };

  public navigateToLogin(){
    this.router.navigate(['/login']);
  }

  public navigateToResetPassword(){
    this.router.navigate(['/forgot-password']);
  }
}
